/* [PATCH aplikacije-fe v1] Skupna lupina vstopnih strani (izbira aplikacije, izbira podjetja): brez stranskega menija,
   logo (isti SVG kot v DashboardLayout), tema, odjava. */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sun, Moon, LogOut } from 'lucide-react';
import { useAuthStore } from '../stores/authStore';
import { deloSledilec } from '../lib/deloSledilec';

export function VstopnaLupina({ children, naslov, podnaslov, nazaj }: {
  children: React.ReactNode; naslov?: string; podnaslov?: string; nazaj?: { label: string; to: string }; // [PATCH aplikacije-fe v1b] naslov neobvezen
}) {
  const { logout, toggleTheme, theme } = useAuthStore();
  const navigate = useNavigate();
  const odjava = () => { deloSledilec.ponastavi(); logout(); navigate('/prijava'); };
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50 dark:from-gray-950 dark:via-gray-900 dark:to-gray-950 text-gray-900 dark:text-white">
      <header className="h-14 flex items-center gap-3 px-6 border-b border-gray-200/70 dark:border-gray-800 bg-white/60 dark:bg-gray-900/60 backdrop-blur">
        <svg viewBox="-2 14 86 82" className="h-8 w-8 flex-shrink-0 text-gray-900 dark:text-white" aria-hidden="true">
          <polygon points="46.5,20.7 40.5,19 35.3,21.8 3.5,72.8 15.7,72.5 23.2,61.2 37.2,60.7 42.3,52.3 29.2,52.3 29,51.3 41.2,32 52.3,47.7 58.7,39.3" fill="currentColor" />
          <polygon points="39.8,72.5 49.3,72.8 59.3,58 60.3,57.7 70.5,72.8 80.2,72.8 61.8,44.7 59.8,44.7" fill="#2563EB" />
        </svg>
        <span className="font-bold text-2xl tracking-tight"><span className="text-gray-900 dark:text-white">Alfa</span><span className="text-blue-600">Berg</span></span>
        <div className="ml-auto flex items-center gap-1">
          <button onClick={toggleTheme} title="Tema" className="p-2 rounded-lg text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-800">
            {theme === 'dark' ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
          </button>
          <button onClick={odjava} title="Odjava" className="p-2 rounded-lg text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-950">
            <LogOut className="w-5 h-5" />
          </button>
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-6 py-10">
        {nazaj && (
          <button onClick={() => navigate(nazaj.to)} className="text-sm text-gray-500 hover:text-blue-600 mb-4">← {nazaj.label}</button>
        )}
        {naslov && <h1 className="text-3xl font-bold tracking-tight">{naslov}</h1>}{/* [PATCH aplikacije-fe v1b] */}
        {podnaslov && <p className="text-gray-500 dark:text-gray-400 mt-1 mb-8">{podnaslov}</p>}
        {children}
      </main>
    </div>
  );
}
